module.exports = __webpack_public_path__ + "img/popup-ngoi-sao-08-1000w.8d579a68.jpg";